package com.kinoshazam.model

import kotlinx.serialization.Serializable

@Serializable
data class ServerResult<T>(
    val result: T? = null,
    val errorMessage: String = "",
)